/**
 * Arsenal de 50 Mensagens Personalizadas de Aniversário para WhatsApp
 * Variáveis dinâmicas suportadas:
 * {cliente}   -> Nome do cliente
 * {atendente} -> Nome da atendente responsável (ex: Diana)
 * {otica}     -> Nome da ótica (ex: Óticas Diana)
 */

export const BIRTHDAY_TEMPLATES: string[] = [
  // 1
  "Olá {cliente}, tudo bem? Aqui é a {atendente} da {otica}! 🎂 Hoje é o seu dia especial e toda a nossa equipe quer lhe desejar um Feliz Aniversário! Que seu novo ciclo seja repleto de saúde, muitas realizações e momentos inesquecíveis. Parabéns! 🎉✨",

  // 2
  "Parabéns, {cliente}! 🎈 Aqui é a {atendente} da {otica}. Passando para celebrar a sua vida e desejar um ano iluminado, com muita paz, saúde e prosperidade. Um grande abraço de toda a nossa equipe! 👓🥳",

  // 3
  "Oi {cliente}! 🌸 Sou a {atendente} da {otica}. Hoje queremos comemorar com você mais um ano de vida! Que seus olhos vejam sempre motivos para sorrir e se alegrar. Feliz Aniversário com muito carinho! 🎂🎉",

  // 4
  "Feliz Aniversário, {cliente}! 🎁 Aqui é a {atendente} da {otica}. Desejo que seu dia seja tão brilhante e especial quanto você é para nós. Que não faltem motivos para comemorar com quem você ama! 🥂✨",

  // 5
  "Olá, {cliente}! Aqui é a {atendente} da {otica}! 🎂 Passando para lhe desejar um feliz aniversário cheio de amor, saúde e luz no seu caminho. Venha nos visitar quando puder para tomar um café e ganhar um abraço nosso! ☕👓",

  // 6
  "Hoje o dia é todo seu, {cliente}! 🥳 A {atendente} e toda a equipe da {otica} desejam que este novo ano traga novas conquistas, alegrias sem fim e muita clareza nos seus objetivos. Parabéns! 🎈🎊",

  // 7
  "Parabéns pelo seu dia, {cliente}! ✨ Aqui é a {atendente} da {otica}. Que sua jornada seja cheia de cores vibrantes, saúde e paz. Temos imensa alegria em ter você como nosso cliente e amigo! 🎂👓",

  // 8
  "Oi {cliente}! 🌟 Aqui é a {atendente} da {otica}. Desejamos a você um Feliz Aniversário muito abençoado! Que você continue enxergando a vida com essa alegria contagiante. Felicidades sempre! 🎉🎁",

  // 9
  "Olá {cliente}, feliz vida! 🎂 Sou a {atendente} da {otica}. Que a sua nova idade venha carregada de momentos doces, muita saúde e sucesso. Um brinde ao seu dia especial! 🥂🎈",

  // 10
  "{cliente}, parabéns! 🎊 Aqui é a {atendente} da {otica}. Que o seu aniversário seja cercado de sorrisos sinceros e muito carinho. Um abraço bem apertado de todos nós! 👓💖",

  // 11
  "Olá {cliente}! Aqui é a {atendente} da {otica}. Hoje é um dia para celebrar a sua existência! Que os seus sonhos se realizem e que o seu olhar continue focado nas coisas mais belas da vida. Feliz Aniversário! 🎂🌟",

  // 12
  "Feliz Aniversário, {cliente}! 🎉 A {atendente} e a equipe da {otica} estão em festa por você hoje. Desejamos que seu novo ciclo seja leve, próspero e cheio de boas surpresas. Parabéns! 🎈✨",

  // 13
  "Oi, {cliente}! 👓 Sou a {atendente} da {otica}. Que alegria comemorar o seu aniversário! Que a sua visão de futuro seja repleta de prosperidade e muitas vitórias. Um feliz aniversário para você! 🎂🎁",

  // 14
  "Parabéns, {cliente}! 🥳 Aqui é a {atendente} da {otica}. Que neste aniversário você receba em dobro todo o carinho que espalha pelo mundo. Muita saúde, harmonia e momentos felizes! 🥂🎈",

  // 15
  "Olá, {cliente}! 🌸 A {atendente} da {otica} passando para desejar um Feliz Aniversário repleto de paz, bênçãos e realizações. Aproveite bastante o seu dia! 🎂🎊",

  // 16
  "Felicidades mil para você, {cliente}! 🌟 Sou a {atendente} da {otica}. Que cada novo dia deste ciclo traga motivos para celebrar e sorrir. Um abraço caloroso da nossa equipe! 👓🎉",

  // 17
  "{cliente}, que seu dia seja maravilhoso! 🎂 Aqui é a {atendente} da {otica}. Desejamos a você saúde de ferro, energia positiva e grandes conquistas neste novo ano de vida! Parabéns! 🎈🎁",

  // 18
  "Parabéns pra você, {cliente}! 🥳 Aqui é a {atendente} da {otica}. Que a felicidade esteja sempre no seu horizonte e que você continue trilhando caminhos de sucesso. Feliz Aniversário! 🥂✨",

  // 19
  "Olá {cliente}! Sou a {atendente} da {otica} e não poderia deixar o seu aniversário passar em branco! 🎂 Desejo a você um dia festivo, com muito amor de quem você quer bem. Parabéns! 💖🎉",

  // 20
  "Feliz Aniversário, {cliente}! 🎈 Aqui é a {atendente} da {otica}. Que nunca lhe faltem motivos para sorrir e que a sua vida tenha sempre a nitidez da mais pura felicidade! Abraços! 👓✨",

  // 21
  "Oi {cliente}! 🎁 Sou a {atendente} da {otica}. Hoje celebramos mais um ano da sua vida com muita gratidão por tê-lo(a) conosco. Que seu novo ciclo venha cheio de saúde e realizações! Parabéns! 🎂🥳",

  // 22
  "Parabéns pelo seu aniversário, {cliente}! 🌟 A {atendente} e toda a {otica} desejam a você 365 novos dias de sucesso, paz e muita luz. Tenha um dia inesquecível! 🎈🎊",

  // 23
  "Olá, {cliente}! 🎂 Aqui é a {atendente} da {otica}. Que o dia de hoje seja o ponto de partida para um ano extraordinário, cheio de vitórias e alegria. Feliz Aniversário! 🥂👓",

  // 24
  "Feliz vida, {cliente}! 🎉 Sou a {atendente} da {otica}. Desejo que seu aniversário seja comemorado com muita festa, amigos reunidos e muito carinho. Felicidades sem medida! 🎂🎈",

  // 25
  "Oi {cliente}, parabéns! 🌸 Aqui é a {atendente} da {otica}. Que seu coração se encha de paz e gratidão neste dia tão lindo. Desejamos um Feliz Aniversário cheio de momentos especiais! 👓✨",

  // 26
  "Olá {cliente}! 🥳 A {atendente} da {otica} mandando um super abraço no seu aniversário! Que a sua vida continue sendo um exemplo de brilho e simpatia. Parabéns pelo seu dia! 🎂🎁",

  // 27
  "Feliz Aniversário, {cliente}! 🎈 Sou a {atendente} da {otica}. Que as melhores oportunidades e as maiores alegrias venham ao seu encontro neste novo ciclo. Parabéns e tudo de bom! 🥂🎉",

  // 28
  "Oi, {cliente}! ✨ Aqui é a {atendente} da {otica}. Hoje brindamos à sua vida! Que a sua caminhada seja leve, seus olhos enxerguem sempre o melhor e seus dias sejam iluminados. Feliz Aniversário! 🎂👓",

  // 29
  "Parabéns, {cliente}! 🎊 A {atendente} e a equipe da {otica} passam para deixar os mais sinceros votos de paz, serenidade, saúde e muitas alegrias no seu aniversário. Viva o seu dia! 🎈🥳",

  // 30
  "Olá {cliente}! 🎂 Sou a {atendente} da {otica}. Que Deus e o universo reservem o melhor para você neste novo ano de vida. Um Feliz Aniversário repleto de carinho e realizações! 🌟💖",

  // 31
  "Feliz Aniversário, {cliente}! 👓🎉 Aqui é a {atendente} da {otica}. Passando para agradecer pela sua amizade e confiança, e desejar um ano novinho em folha repleto de bênçãos e sorrisos! 🎁✨",

  // 32
  "Oi {cliente}! 🥳 Sou a {atendente} da {otica}. Que seu dia seja doce, alegre e cheio de boas conversas e abraços sinceros. Feliz Aniversário de coração! 🎂🎈",

  // 33
  "Parabéns pra você, {cliente}! 🌸 A {atendente} da {otica} deseja que a felicidade faça morada definitiva na sua vida. Saúde, paz e muitas conquistas no seu novo ciclo! 🥂🎊",

  // 34
  "Olá {cliente}! 🌟 Aqui é a {atendente} da {otica}. Que você comemore este aniversário com a certeza de que o melhor ainda está por vir. Desejamos dias brilhantes e cheios de vitalidade! 🎂👓",

  // 35
  "Feliz Aniversário, {cliente}! 🎈 Sou a {atendente} da {otica}. Que a sua vida seja sempre focada em momentos felizes e que seu sorriso nunca perca o brilho. Parabéns pelo seu dia especial! 🎉✨",

  // 36
  "Oi {cliente}! 🎁 Aqui é a {atendente} da {otica}. Que orgulho ter você como cliente especial! Desejo que seu aniversário seja cercado de amor e que o novo ano traga muitas novidades boas. Felicidades! 🎂🥳",

  // 37
  "Parabéns, {cliente}! 🥂 A {atendente} e todo o time da {otica} te mandam aquele abraço bem caloroso! Que você desfrute cada instante do seu dia com muita alegria no coração! 🎈👓",

  // 38
  "Olá {cliente}, feliz dia! 🎂 Sou a {atendente} da {otica}. Que o seu novo ano chegue com novos horizontes, muita saúde e momentos inesquecíveis ao lado de quem você ama. Parabéns! 🌟🎉",

  // 39
  "{cliente}, um Feliz Aniversário especial para você! 🎊 Aqui é a {atendente} da {otica}. Que você siga iluminando todos ao seu redor com sua energia e simpatia. Tudo de melhor hoje e sempre! 💖🎈",

  // 40
  "Oi, {cliente}! ✨ Sou a {atendente} da {otica}. Passando para lembrar o quanto seu dia é especial para nós! Que seu aniversário seja cheio de boas vibrações e muita saúde. Parabéns! 🎂👓",

  // 41
  "Feliz Aniversário, {cliente}! 🥳 Aqui é a {atendente} da {otica}. Desejo que seu coração transborde de gratidão e alegria por mais um ano vivido com tanta dignidade e luz. Grande abraço! 🎁🥂",

  // 42
  "Parabéns pelo seu dia, {cliente}! 🎈 A {atendente} da {otica} deseja que os seus dias sejam leves, suas risadas frequentes e seus sonhos plenamente realizados. Feliz Aniversário! 🎂🎉",

  // 43
  "Olá {cliente}! 🌸 Sou a {atendente} da {otica}. Que o seu novo ciclo traga clareza nos objetivos, vigor na caminhada e muita paz no coração. Um Feliz Aniversário iluminado! 👓✨",

  // 44
  "Felicidades, {cliente}! 🎂 Aqui é a {atendente} da {otica}. Que este seja o início do melhor ano da sua vida, cheio de realizações, boa saúde e muitos motivos para festejar! Parabéns! 🎈🎊",

  // 45
  "Oi {cliente}! 🌟 A {atendente} da {otica} te deseja um Feliz Aniversário repleto de surpresas boas e pessoas queridas ao seu lado. Aproveite muito o seu dia! 🥂🥳",

  // 46
  "Parabéns pra você, {cliente}! 🎁 Sou a {atendente} da {otica}. Que nunca lhe falte saúde, serenidade e fé para seguir conquistando todos os seus sonhos. Um dia abençoado! 🎂👓",

  // 47
  "Olá {cliente}! ✨ Aqui é a {atendente} da {otica}. Toda a nossa loja se une hoje para te mandar um abraço carinhoso de aniversário. Que a vida continue te presenteando com momentos lindos! Parabéns! 🎈💖",

  // 48
  "Feliz vida nova, {cliente}! 🥳 Sou a {atendente} da {otica}. Que o seu dia seja repleto de sorrisos, abraços sinceros e muito amor. Parabéns pelo seu aniversário! 🎂🎉",

  // 49
  "Oi {cliente}! 🌸 Aqui é a {atendente} da {otica}. Desejamos que seu aniversário seja o reflexo de tudo de bom que você planta: leveza, generosidade e alegria. Feliz Aniversário com carinho! 👓🎈",

  // 50
  "Parabéns pelo seu aniversário, {cliente}! 🎂🎉 Aqui é a {atendente} da {otica}. Queremos que saiba que sua amizade é muito valiosa para nós. Desejamos que seu novo ciclo seja espetacular, cheio de saúde, paz e muitas felicidades! 🥂✨",
];

const LAST_SENT_KEY = 'optisaas_last_sent_birthday_msg_index';

/**
 * Seleciona aleatoriamente uma das 50 mensagens garantindo que não repita
 * a mesma mensagem consecutivamente, e substitui os dados dinâmicos.
 */
export function getRandomBirthdayMessage(
  customerName: string,
  attendantName: string = 'Diana',
  storeName: string = 'Óticas Diana'
): { message: string; templateIndex: number } {
  // Pega o primeiro nome com tratamento elegante
  const cleanCustomerName = customerName?.trim() || 'Cliente Especial';
  const firstName = cleanCustomerName.split(' ')[0];

  const total = BIRTHDAY_TEMPLATES.length;

  let lastIndex = -1;
  try {
    const saved = localStorage.getItem(LAST_SENT_KEY);
    if (saved !== null) {
      lastIndex = parseInt(saved, 10);
    }
  } catch {
    lastIndex = -1;
  }

  // Sorteia um índice diferente do último
  let newIndex = Math.floor(Math.random() * total);
  if (total > 1 && newIndex === lastIndex) {
    newIndex = (newIndex + 1 + Math.floor(Math.random() * (total - 1))) % total;
  }

  try {
    localStorage.setItem(LAST_SENT_KEY, newIndex.toString());
  } catch {
    // ignore
  }

  const template = BIRTHDAY_TEMPLATES[newIndex] || BIRTHDAY_TEMPLATES[0];

  const formattedAttendant = attendantName?.trim() || 'Diana';
  const formattedStore = storeName?.trim() || 'Óticas Diana';

  const message = template
    .replace(/{cliente}/g, firstName)
    .replace(/{atendente}/g, formattedAttendant)
    .replace(/{otica}/g, formattedStore);

  return { message, templateIndex: newIndex + 1 };
}

/**
 * Monta o link wa.me direto com a mensagem sorteada
 */
export function buildBirthdayWhatsAppLink(
  phone: string,
  customerName: string,
  attendantName?: string,
  storeName?: string
): { whatsappUrl: string; message: string; templateIndex: number } {
  const cleanPhone = phone.replace(/\D/g, '');
  const { message, templateIndex } = getRandomBirthdayMessage(customerName, attendantName, storeName);
  
  // Prefixo do Brasil se necessário
  const fullPhone = cleanPhone.startsWith('55') ? cleanPhone : `55${cleanPhone}`;
  const whatsappUrl = `https://wa.me/${fullPhone}?text=${encodeURIComponent(message)}`;

  return { whatsappUrl, message, templateIndex };
}
